import { Box } from "@mui/material";

// Photo with an offset gold frame behind it
export function FramedImage({ src, alt, aspectRatio = "4 / 5", objectPosition = "center", maxWidth = 460 }) {
  return (
    <Box sx={{ position: "relative", width: "100%", maxWidth, justifySelf: "center", mr: 2, mb: 2 }}>
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          transform: "translate(16px, 16px)",
          border: "1px solid",
          borderColor: "primary.main",
          borderRadius: 4,
          opacity: 0.6,
        }}
      />
      <Box
        component="img"
        src={src}
        alt={alt}
        loading="lazy"
        sx={{
          position: "relative",
          display: "block",
          width: "100%",
          aspectRatio,
          objectFit: "cover",
          objectPosition,
          borderRadius: 4,
        }}
      />
    </Box>
  );
}
